module.exports = __webpack_public_path__ + "static/paris-013-1175df81131b0638170ab92ca3dd5832.jpg";